<template>
  <div v-if="!item.hidden">
    <template
      v-if="
        hasOneShowingChild(item.children, item) &&
          (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
          !item.alwaysShow
      "
    >
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item
          :index="resolvePath(onlyOneChild.path)"
          :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <div
            class="onlyOneChild"
            :class="{
              isOpen: !isCollapse,
              start:
                (!(item.meta && item.meta.icon) || onlyOneChild.meta.icon) &&
                isCollapse
            }"
          >
            <div
              v-if="onlyOneChild.meta.icon"
              :class="{ 'margin-r16': !isCollapse }"
            >
              <i
                v-if="onlyOneChild.meta.icon.includes('el-icon')"
                :class="`'${onlyOneChild.meta.icon}' 'sub-el-icon'`"
              ></i>
              <svg-icon
                v-else
                :iconClass="onlyOneChild.meta.icon"
                style="width:1.6em;height:1.6em;margin-right:0"
              />
            </div>
            <div
              v-if="item.meta && item.meta.icon"
              :class="{ 'margin-r16': !isCollapse }"
            >
              <i
                v-if="item.meta.icon.includes('el-icon')"
                :class="`'${item.meta.icon}' 'sub-el-icon'`"
              ></i>
              <svg-icon
                v-else
                :iconClass="item.meta.icon"
                style="width:1.6em;height:1.6em;margin-right:0"
              />
            </div>
            <div>
              {{ generateTitle(onlyOneChild.meta.title) }}
            </div>
          </div>
          <!-- <item
            :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
            :title="generateTitle(onlyOneChild.meta.title)"
          /> -->
        </el-menu-item>
      </app-link>
    </template>

    <template v-else>
      <el-submenu
      ref="subMenu"
      :index="resolvePath(item.path)"
      popper-append-to-body
    >
      <template slot="title">
        <item
          v-if="item.meta"
          :icon="item.meta && item.meta.icon"
          :title="generateTitle(item.meta.title)"
        />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
    </template>
  </div>
</template>

<script>
import path from 'path'
import { generateTitle } from '@/utils/i18n'
import { isExternal } from '@/utils/validate'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'
import { mapGetters } from 'vuex'
export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {}
  },
  computed: {
    ...mapGetters(['sidebar','userInfo']),
    isCollapse() {
      return !this.sidebar.opened
      // return true
    }
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    },

    generateTitle
  }
}
</script>

<style lang="scss" scoped>
.onlyOneChild {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  div {
    line-height: 1;
    font-size: 12px;
  }
}

.isOpen {
  flex-direction: inherit;
  align-items: center;
  justify-content: start;
}

.start {
  align-items: start;
}

.margin-r16 {
  margin-right: 16px;
}
</style>
